<template>
  <div v-if="attachments.length > 0">
    <ul style="padding-left: 0; list-style-type: none">
      <li v-for="(attachment, index) in attachments" :key="index">
        <ImagePreview
          :image="attachment"
          v-if="fileType(attachment) === 'image'"
          @clicked="viewFile"
        />
        <v-chip
          v-if="fileType(attachment) !== 'image'"
          class="mb-1 rounded-10 primary--text"
          small
          @click="viewFile(attachment)"
        >
          <v-icon small>mdi-paperclip</v-icon>
          {{ cleanFilename(attachment) }}
        </v-chip>
      </li>
    </ul>
    <FileViewer v-model="file" />
  </div>
</template>

<script>
import ImagePreview from "./MessageAttachments/ImagePreview.vue"
import FileViewer from "@/components/shared/FileViewer.vue"
import { fileType } from "@/utils"

export default {
  props: ["message"],

  components: { ImagePreview, FileViewer },

  data() {
    return {
      file: null
    }
  },

  computed: {
    attachments() {
      if (!this.message?.attachments?.length) {
        return []
      }
      return this.message.attachments
    }
  },

  methods: {
    viewFile(file) {
      this.file = file
    },

    fileType,

    cleanFilename(attachment) {
      return attachment.file_name.slice(7)
    }
  }
}
</script>
